import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { NAV_LINKS } from '../constants/content';
import { SITE_NAME } from '../constants/site';
import { openZohoChat } from '../utils/openZohoChat';
import Icon from './Icon';
import Logo from './Logo';

function NavGroup({ link, onNavigate }) {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const active = link.children.some((c) => c.to === pathname);

  return (
    <li
      className={`nav__item nav__item--group ${open ? 'is-open' : ''}`}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <button
        type="button"
        className={`nav__link nav__toggle ${active ? 'active' : ''}`}
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        {link.label} <Icon name="chevron" size={14} />
      </button>
      <ul className="nav__sub">
        {link.children.map((child) => (
          <li key={child.to}>
            <NavLink to={child.to} onClick={onNavigate}>
              {child.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </li>
  );
}

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();
  const close = () => setMenuOpen(false);

  useEffect(close, [pathname]);

  return (
    <header className="site-header">
      <div className="topline">
        <div className="container topline__inner">
          <span>Independent help for Ancestry users · Not affiliated with Ancestry.com</span>
          <span className="topline__right">
            <Icon name="clock" size={14} /> Live chat open day &amp; night
          </span>
        </div>
      </div>

      <div className="masthead">
        <div className="container masthead__inner">
          <Link to="/" className="brand" aria-label={`${SITE_NAME} home`}>
            <Logo size={58} />
            <span className="brand__text">
              <span className="brand__name">AncestryHelp</span>
              <span className="brand__tag">Helps · Updates · Troubleshooting</span>
            </span>
          </Link>
          <button type="button" className="btn btn--primary masthead__cta" onClick={openZohoChat}>
            <Icon name="chat" size={18} /> Live Chat
          </button>
          <button
            type="button"
            className="menu-btn"
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
          >
            <Icon name={menuOpen ? 'close' : 'menu'} size={26} />
          </button>
        </div>
      </div>

      <nav className={`nav ${menuOpen ? 'is-open' : ''}`} aria-label="Primary">
        <div className="container">
          <ul className="nav__list">
            {NAV_LINKS.map((link) =>
              link.children ? (
                <NavGroup key={link.label} link={link} onNavigate={close} />
              ) : (
                <li key={link.to} className="nav__item">
                  <NavLink to={link.to} end={link.to === '/'} className="nav__link" onClick={close}>
                    {link.label}
                  </NavLink>
                </li>
              )
            )}
            <li className="nav__item nav__item--chat">
              <button type="button" className="nav__link" onClick={openZohoChat}>
                <Icon name="chat" size={16} /> Live Chat
              </button>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  );
}
